import { useState, useCallback } from "react";
import { generateEmbedding } from "@/lib/generateEmbedding.functions";

interface VectorMatch {
  id: string;
  content: string;
  metadata: Record<string, any>;
  similarity: number;
}

interface VectorContextResult {
  matches: VectorMatch[];
  isLoading: boolean;
  error: string | null;
  search: (text: string, language?: string) => Promise<VectorMatch[]>;
}

export const useVectorContext = (): VectorContextResult => {
  const [matches, setMatches] = useState<VectorMatch[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const search = useCallback(async (text: string, language?: string): Promise<VectorMatch[]> => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await generateEmbedding({
        data: { text, pageContext: { language } },
      });

      const results = (data?.matches || []) as VectorMatch[];
      setMatches(results);
      return results;
    } catch (e) {
      const msg = e instanceof Error ? e.message : "Unknown error";
      setError(msg);
      console.error("useVectorContext error:", msg);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { matches, isLoading, error, search };
};
